import { COMMUNITY_TYPE } from '../../constants'

export const COMMUNITY_TYPE_DESCRIPTIONS = {
  [COMMUNITY_TYPE.OPEN]:
    'configuration_sidebar.change_community_type_modal.description_open_community',
  [COMMUNITY_TYPE.EXCLUSIVE]:
    'configuration_sidebar.change_community_type_modal.description_exclusive_community',
  [COMMUNITY_TYPE.PUBLIC]:
    'configuration_sidebar.change_community_type_modal.description_public_community'
}
